import { PricelistUpdatePage } from '@/features/pricelist/pages/PricelistUpdate'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/pricelist/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["pricelist.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PricelistUpdatePage,
})
